import { Component, input, output, TemplateRef } from '@angular/core';
import { NgTemplateOutlet, NgFor, NgIf } from '@angular/common';

/**
 * Um item da lista de conversações.
 *
 */
export type SimpleListItem = {
    id?: string;
    description: string;
    parent?: SimpleListItem;
    children?: SimpleListItem[];
    data?: any;
    itemClass?: string;
};

@Component({
    selector: 'ai-simple-list-item-template',
    template: '<ng-content></ng-content>',
    standalone: true,
})
export class SimpleListItemTemplate {
    item = input<SimpleListItem>();
    contextMenu = output<void>();
}

/**
 * Componente que exibe a lista de conversações de um usuário.
 * A lista é exibida agrupada por mês do ano corrente.
 *
 */
@Component({
    selector: 'ai-simple-list',
    templateUrl: 'simple-list.component.html',
    imports: [NgFor, NgIf, NgTemplateOutlet],
})
export class SimpleList {
    /** Emitido quando o usuário clica em um item da lista. */
    itemClicked = output<SimpleListItem>();

    /** Emitido ao acionar o menu de contexto (clique direito) em um item. */
    contextMenuItemClicked = output<SimpleListItem>();

    /** Itens a serem exibidos. */
    items = input<SimpleListItem[]>();

    /** Template opcional para renderizar cada item (recebe o item no contexto). */
    itemTemplate = input<TemplateRef<any> | undefined>();

    /** Espaçamento interno (padding CSS) da lista. */
    listPadding = input<string>('0px');

    /**
     * Trata o evento de clique em um item da lista.
     *
     * @param item Item que foi clicado.
     */
    onContextMenuItemClicked(item: SimpleListItem): void {
        this.contextMenuItemClicked.emit(item);
    }

    /**
     * Trata o evento de clique em uma conversação na View.
     *
     * @param conversation Conversação que foi clicada.
     */
    onItemClicked(item: SimpleListItem): void {
        this.itemClicked.emit(item);
    }
}
